import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    versionPage: {
        padding: 0,
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100vh',
        maxWidth: '100%',
        border: 'none',
        marginTop: 28,
        [theme.breakpoints.down('xs')]: {
            height: '100%',
            padding: '20px 14px 20px 14px',
            marginTop: 5,

        },
    }
}));

export default useStyles;
